
import { Component, Vue } from 'vue-property-decorator'
import { UntrustedAuthenticationService } from '@/store'
import { RouterUtils } from '@/commons/utils/router'

@Component
export default class ModalBoxUntrustedAuthenticationContent extends Vue {
    firstName = ''
    lastName = ''
    personCode = ''

    async login () {
        await UntrustedAuthenticationService.untrustedLogin(this.personCode, this.firstName, this.lastName)
        await this.$router.push('/', RouterUtils.setFocusToBody)
    }
}
